var variazioni_lotto = function () {

    var variazioni_lotto = this;

    this.bindEvents = function () {

    };

};
